export function asGrafanaStat(...names) {
    return names.join('.');
}
